import { Chip, styled } from '@mui/material';
import { MODELS_CALENDAR_EVENT_COLORS } from 'dashboard409a/common/constants/calendar';
import { getCalendarColorPalette } from 'dashboard409a/hooks/useColorPalette';

// Map ModelStatus string values to CalendarColorPalette keys
const MODEL_STATUS_TO_PALETTE_KEY: Record<string, keyof ReturnType<typeof getCalendarColorPalette>> = {
  'Draft': 'DRAFT',
  'Review': 'REVIEW',
  'In-process ScalarUSA': 'IN_PROCESS_SCALAR_USA',
  'Final': 'FINAL',
  'COMPLETE': 'COMPLETE',
  'WAITING': 'WAITING',
};

const getModelStatusColor = (status?: string) => {
  if (!status) {
    return MODELS_CALENDAR_EVENT_COLORS.DEFAULT;
  }

  const palette = getCalendarColorPalette();
  const paletteKey = MODEL_STATUS_TO_PALETTE_KEY[status];
  
  return paletteKey ? palette[paletteKey] : MODELS_CALENDAR_EVENT_COLORS.DEFAULT;
};

interface ModelStatusChipProps {
  status?: string;
}

export const StyledModelStatusChip = styled(Chip)<ModelStatusChipProps>(({ theme, status }) => {
  const statusColor = getModelStatusColor(status);

  return {
    backgroundColor: statusColor,
    color: theme.palette.getContrastText(statusColor),
    borderRadius: '10px',
    padding: `0px ${theme.spacing(1.5)}`,
    fontSize: '14px',
  };
});
